export interface CCTConfigs {
  TIME_THRESHOLD: number;
  TIME_THRESHOLD_SUBSEQUENT: number;
  MAXMIUM_ACCOUNTS: number;
  ACTIVE_SESSION_EVALUATE_INTERVAL: number;
  INTERACTION_REFRESH_LINK_LOGS_TIME: number;
  APP_IDLE_TIME: number;
  APP_TIMEOUT: number;
  APP_SESSION_TIMEOUT: number;
  GENSYS_IDLE_TIME:number;
  OUTBOUND_POPUP_TIME:number;
}

export class awsConfig {
  accessKeyId: string = '';
  secretAccessKey: string = '';
  region: string = '';
}
